import $ from 'jquery';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/finally';
import 'rxjs/add/operator/retry';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/observable/dom/ajax';

export function filterTable({ tableBodyNode, updateItemNumbers, url, noResultsTemplate, itemsTotal, storedFilters, 
  pagination }) {
  const $table = $(tableBodyNode.parentNode);
  const $comparison = $table.parents('.js-comparison-calculator');
  const loadingClassName = 'comparison-table--loading';
  const { submitData: recalculateTableFields } = window.finder.calculators || {};

  (function initialize() {
    const shouldRenderEmptyTable = url === null;

    $table.addClass(loadingClassName);

    if (shouldRenderEmptyTable) {
      renderEmptyTable();
    } else {
      filter();
    }
  }());

  function filter() {
    Observable
      .ajax(url)
      .flatMap(parseResponse)
      .map(updateTableHtml)
      .finally(onTableLoaded)
      .take(1)
      .retry(2)
      .subscribe(() => {});
  }

  function updateTableHtml({ html }) {
    return (tableBodyNode.innerHTML = html);
  }

  function updateTableDataset() {
    if (storedFilters.length) {
      $comparison.attr('data-table-filter', JSON.stringify({ filters: storedFilters }));
    }

    if (tableBodyNode.parentNode.dataset.paginationOffset) {
      tableBodyNode.parentNode.dataset.paginationOffset = 0;
    }
  }

  function lazyLoadImagesOnTable() {
    const unloadedElems = [...tableBodyNode.querySelectorAll('img[data-src], iframe[data-src]')];
    unloadedElems.forEach((img) => (img.setAttribute('src', img.dataset.src)));
  }

  function renderEmptyTable() {
    onTableBodyFetched({})
      .then(() => { }, displayNoResults)
      .then(updateTableHtml)
      .then(onTableLoaded);
  }

  function onTableBodyFetched({ html, productCount, nextOffset }) {
    return new Promise((resolve, reject) => {
      if (!html) {
        reject(getNoResultData());
      } else {
        const itemsCount = (html.match(/<tr/g) || []).length;
        resolve({
          count: itemsCount,
          allProducts: productCount,
          html,
          nextOffset: nextOffset,
        });
      }
    });
  }

  function getNoResultData() {
    return {
      count: 0,
      html: noResultsTemplate,
    }
  }

  function displayResults(results) {
    const { count: currentItemsTotal, allProducts, nextOffset } = results;
    if (nextOffset !== 'undefined') {
      updateItemNumbers({ currentItemsTotal, itemsTotal: allProducts });
    } else {
      updateItemNumbers({ currentItemsTotal, itemsTotal });
    }

    if (pagination) {
      togglePaginationButton(currentItemsTotal, allProducts);
    }

    return results;
  }

  function displayNoResults(results) {
    const { count } = results;
    updateItemNumbers({ currentItemsTotal: 0, itemsTotal: count });

    if (pagination) {
      togglePaginationButton(0, count);
    }

    return results;
  }

  function togglePaginationButton(currentItemsTotal, itemsTotal) {
    const showLoadMoreButton = new CustomEvent('showLoadMoreButton');
    showLoadMoreButton.params = { currentItemsTotal, itemsTotal };
    document.dispatchEvent(showLoadMoreButton);
  }

  function parseResponse({ response }) {
    return Observable.fromPromise(onTableBodyFetched(response))
      .map(displayResults)
      .catch((data) => Observable.of(displayNoResults(data)))
  }

  function onTableLoaded() {
    const $tooltips = $table.find('[rel="popover"]');

    updateTableDataset();

    $table
      .trigger('update')
      .trigger('sorton')
      .removeClass(loadingClassName);

    $tooltips
      .trigger('loadpopover');

    lazyLoadImagesOnTable();

    if (recalculateTableFields) {
      recalculateTableFields($comparison);
    }
  };
}

export function extractFilters(form) {
  return [].slice.call(form.elements)
    .map(function parseFilterData(elem) {
      const { type, name, value, checked } = elem;

      if (type === 'hidden' || (type === 'radio' && checked)) {
        return [name, value];
      }

      if (type === 'checkbox' && checked) {
        return [name, value];
      }

      if (type === 'select-one') {
        return [name, elem.children[elem.selectedIndex].value];
      }

      if (type === 'text') {
        const [label, decorator] = name.split('%');
        const encodeValue = encodeURI(value);
        return decorator && value.length ? [label, `${decorator}|${encodeValue}`] : null;
      }

      return null;
    })
    .filter(elem => elem != null);
}



// WEBPACK FOOTER //
// ./src/utils/FiltersService.js